import type { ObjectivesRange } from './queries';

export type ObjectiveRangePreset = '7d' | '30d' | '90d';

const PRESET_DAYS: Record<ObjectiveRangePreset, number> = { '7d': 7, '30d': 30, '90d': 90 };

export function resolveObjectivePreset(
  preset: ObjectiveRangePreset,
  maxFactDate: string | null,
  today = new Date(),
): ObjectivesRange {
  const fallback = today.toISOString().slice(0, 10);
  const end = isIsoDate(maxFactDate) ? maxFactDate : fallback;
  const endDate = new Date(`${end}T00:00:00Z`);
  endDate.setUTCDate(endDate.getUTCDate() - (PRESET_DAYS[preset] - 1));
  return { start: endDate.toISOString().slice(0, 10), end };
}

export function isValidObjectiveCustomRange(start: string, end: string): boolean {
  return isIsoDate(start) && isIsoDate(end) && start <= end;
}

function isIsoDate(value: string | null): value is string {
  if (!value || !/^\d{4}-\d{2}-\d{2}$/.test(value)) return false;
  const parsed = new Date(`${value}T00:00:00Z`);
  return !Number.isNaN(parsed.valueOf()) && parsed.toISOString().slice(0, 10) === value;
}
